import { memo } from 'react';
import { getNumberSuffix, pluralize } from '@siteless/util';
import ObjectiveStateResource from '../resources/ObjectiveState';
import useCopy from '../util/useCopy';
import TrophyIcon from './TrophyIcon';
import { HEADER_HEIGHT } from './MobileScoredList';

export let TierRankPill = memo(({
  rank,
  points,
  hasScoringStarted,
  incompleteTier,
  tierSize,
}: {
  rank?: number;
  points?: number;
  hasScoringStarted?: boolean;
  incompleteTier?: boolean;
  tierSize?: number;
}) => {
  let copy = useCopy();
  let objectiveState = ObjectiveStateResource.use();

  if (!hasScoringStarted && !incompleteTier) return null;

  return (
    <div className="flex items-start justify-center" style={{ height: HEADER_HEIGHT }}>
      <div className="bg-neutral-0 flex items-center justify-center rounded-full border-4 border-neutral-100 px-3 py-1 text-sm font-medium text-purple-900 shadow-lg">
        {(rank || 0) === 1 && (points || 0) > 0 && (
          <TrophyIcon className="mr-2 h-5 w-5" />
        )}
        {incompleteTier ? (
          copy['Incomplete Ballots 🥲']
        ) : objectiveState.didCeremonyEnd && rank === 1 ? (
          pluralize({ hideCount: true, count: tierSize || 1, singular: copy.Winner, plural: copy.winners }).toUpperCase()
        ) : (
          <>
            {/* TODO: figure out spanish ordinals */}
            {getNumberSuffix(rank || 0)} Place
          </>
        )}
      </div>
    </div>
  );
});
